import PROMISE_STATUS from 'constants/promiseStatus.const';

const allSettled = async (promises) => {
  // SEE: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/allSettled
  // SEE: https://tc39.es/ecma262/#sec-promise.allsettled

  if (!Array.isArray(promises)) {
    throw new TypeError(`${promises} is not an  Array`);
  }

  if (!promises.length) {
    return [];
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const promise of promises) {
    if (!(promise instanceof Promise)) {
      throw new TypeError(`${promise} is not an instance of Promise`);
    }
  }

  return new Promise((resolve) => {
    const results = [];

    let remaining = promises.length;
    const settle = () => {
      remaining -= 1;
      if (!remaining) {
        resolve(results);
      }
    };

    promises.forEach(
      (promise, index) =>
        void promise
          .then((value) => {
            results[index] = { status: PROMISE_STATUS.fulfilled, value };
            settle();
          })
          .catch((reason) => {
            results[index] = { status: PROMISE_STATUS.rejected, reason };
            settle();
          }),
    );
  });
};

// noinspection JSUnusedGlobalSymbols
export default allSettled;
